import React from 'react';
import { Box, Typography, Button, Divider, Slider } from '@mui/material';

const RowColControls = ({
  knitdata,
  setKnitdata,
  history,
  setHistory,
  historyIndex,
  setHistoryIndex,
  cellSize,
  setCellSize,
  startWithRS,
  setStartWithRS
}) => {
  // Use the same default stitch as ChartEditor
  const DEFAULT_STITCH = 'k';
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Typography variant="body2">Rows: {knitdata.length}</Typography>
      <Button size="small" variant="outlined" onClick={() => {
        setKnitdata([...knitdata, Array(knitdata[0].length).fill(DEFAULT_STITCH)]);
        setHistory([...history.slice(0, historyIndex + 1), JSON.stringify([...knitdata, Array(knitdata[0].length).fill(DEFAULT_STITCH)])]);
        setHistoryIndex(historyIndex + 1);
      }}>+ Row</Button>
      <Button size="small" variant="outlined" disabled={knitdata.length <= 1} onClick={() => {
        setKnitdata(knitdata.slice(0, -1));
        setHistory([...history.slice(0, historyIndex + 1), JSON.stringify(knitdata.slice(0, -1))]);
        setHistoryIndex(historyIndex + 1);
      }}>- Row</Button>
      <Typography variant="body2" sx={{ ml: 2 }}>Cols: {knitdata[0].length}</Typography>
      <Button size="small" variant="outlined" onClick={() => {
        setKnitdata(knitdata.map(row => [...row, DEFAULT_STITCH]));
        setHistory([...history.slice(0, historyIndex + 1), JSON.stringify(knitdata.map(row => [...row, DEFAULT_STITCH]))]);
        setHistoryIndex(historyIndex + 1);
      }}>+ Col</Button>
      <Button size="small" variant="outlined" disabled={knitdata[0].length <= 1} onClick={() => {
        setKnitdata(knitdata.map(row => row.slice(0, -1)));
        setHistory([...history.slice(0, historyIndex + 1), JSON.stringify(knitdata.map(row => row.slice(0, -1)))]);
        setHistoryIndex(historyIndex + 1);
      }}>- Col</Button>
      <Divider orientation='vertical' flexItem />
      <Typography variant="body2" sx={{ mr: 1 }}>Start with RS:</Typography>
      <Box 
        onClick={() => setStartWithRS(!startWithRS)}
        sx={{
          width: 40,
          height: 24,
          bgcolor: startWithRS ? 'primary.main' : 'grey.300',
          borderRadius: 12,
          p: 0.5,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: startWithRS ? 'flex-end' : 'flex-start',
          transition: 'all 0.2s',
          '&:hover': {
            bgcolor: startWithRS ? 'primary.dark' : 'grey.400',
          }
        }}
      >
        <Box 
          sx={{
            width: 20,
            height: 20,
            bgcolor: 'white',
            borderRadius: '50%',
            boxShadow: 1
          }}
        />
      </Box>
      <Typography variant="body2" sx={{ ml: 1 }}>
        {startWithRS ? 'RS' : 'WS'}
      </Typography>
      <Typography variant="body2" sx={{ ml: 1 }}>Cell Size:</Typography>
      <Slider
        value={cellSize}
        onChange={(_, value) => setCellSize(value)}
        min={16}
        max={36}
        marks
        step={2}
        size="small"
        sx={{ width: 150, mh: 1 }}
        width={60}
      />
      <Typography variant="body2" sx={{ minWidth: 28, textAlign: 'right' }}>{cellSize}px</Typography>
    </Box>
  );
};

export default RowColControls;
